'use client';

import React from 'react';
import { Tooltip } from 'src/components';
import { STATUS_CONFIG } from '../../constants';
import type { UserStatus } from '../../types';

interface UserStatusDotProps {
  status: UserStatus;
}

/**
 * @description Colour-coded dot for a user's lifecycle state. The colour alone
 *              carries no meaning for screen readers or colour-blind users, so
 *              the description is available both as a tooltip and as
 *              screen-reader-only text.
 * @returns React.ReactElement
 */
const UserStatusDot: React.FC<UserStatusDotProps> = ({ status }) => {
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <Tooltip content={config.description} delay={200}>
      <span
        className="inline-flex items-center"
        data-testid={`user-status-${status}`}
        data-status={status}
      >
        <span
          className={`h-2.5 w-2.5 rounded-full ${config.dotClassName}`}
          aria-hidden="true"
        />
        <span className="sr-only">{config.description}</span>
      </span>
    </Tooltip>
  );
};

export default UserStatusDot;
